import { render, staticRenderFns } from "./WorkersSection.vue?vue&type=template&id=3e780b3b&"
import script from "./WorkersSection.vue?vue&type=script&lang=js&"
export * from "./WorkersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports